<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import OrderMedicineAPI from "@/services/standards/ocupationalMedicine/orderMedicineAPI";
import Swal from "sweetalert2";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.4 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.1.4 Evaluaciones médicas ocupacionales",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: 'Medicina ocupacional',
        active: true,
      },
      ],
      userSelected: null,
      Datalist: [],
      itemData: null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      loading: true,

      file: null,
      lastId: 1,
      employeeId: 0,
      guardando: false,
      orderMedicine: {
        ocupational_medical_id: this.$route.params.id,
        note: null,
        file: null,
      },
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(26)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getOrder() {
      OrderMedicineAPI
        .getOrder(this.$route.params.id)
        .then((response) => {
          this.employeeId = response.ocupational_medical.employee.id
          this.orderMedicine = {
            ocupational_medical_id: response.id,
            note: response.note,
            file: response.file,
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.orderMedicine.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/3.1.4/${this.employeeId}/Recomendaciones/${this.orderMedicine.ocupational_medical_id}/${name}`;
        } else {
          url = `sst-prod/${company.nit}/3.1.4/${this.employeeId}/Recomendaciones/${this.orderMedicine.ocupational_medical_id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.orderMedicine.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      this.guardando = true
      this.loading = true
      let document = await this.uploadDocument();
      if (document) {
        OrderMedicineAPI.updateOrder(this.$route.params.id, {
          ocupational_medical_id: this.orderMedicine.ocupational_medical_id,
          note: this.orderMedicine.note,
          file: this.orderMedicine.file,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 26,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 1500)
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1500);
                console.log(error);
              });
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            title: "¡No se ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getOrder()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">

              <div class="row">
                <h4 class="header-title col-6">

                </h4>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 " id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-12 px-2" label="Nota" label-for="note">
                    <b-form-textarea :disabled="!getRole('Editar') || !allowAccess()" type="date" id="note"
                      v-model="orderMedicine.note">
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Editar') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="orderMedicine.file ? getFile(orderMedicine.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
